import "./App.css";
import StitchPage from "./StitchPage";
import Header from "./components/Header";
/* eslint-disable */
import { Backgroound } from "./components/Backgroound";
import { motion } from "framer-motion";
import { KeyFeatures } from "./components/KeyFeatures";
import { Hero } from "./components/Hero";
import { Steps } from "./components/steps";
import Accordion from "./components/faq";
import { IoLogoWhatsapp } from "react-icons/io5";
import { useEffect, useState } from "react";

function App() {
  return <StitchPage />;

  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const audio = new Audio("/pop2.mp3");
      audio.play().catch((err) => console.log("Audio play failed:", err));
    }
  }, [isVisible]);
  return (
    <div className="bg-[#040407] min-h-full relative overflow-x-hidden justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={isVisible ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.1, ease: "easeOut" }}
        className="z-50 fixed bottom-6 right-6 flex flex-row gap-2"
      >
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
            className="chat-bubble"
          >
            Whatsapp
          </motion.div>
        )}
        <motion.div
          whileHover={{
            scale: 1.2,
            transition: { duration: 0.01 },
          }}
          whileTap={{ scale: 0.9 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="h-12 w-12 rounded-full bg-[white]  cursor-pointer transition-all flex justify-center items-center"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://wa.me/+17373438150"
          >
            <IoLogoWhatsapp className="text-4xl text-green-500" />
          </a>
        </motion.div>
      </motion.div>
      <div className="z-50 relative">
        <Header />
      </div>
      <div>
        <Hero />
      </div>
      <div id="features" className="z-20 relative stitch-features-shell">
        <KeyFeatures />
      </div>
      <div className="z-20 relative">
        <Backgroound />
      </div>
      <div>
        <div class="w-screen relative z-30 -mt-[6%]">
          <svg
            className="inline-block fill-current text-[#7632EC]"
            viewBox="0 0 1440 450"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: "scaleX(-1)" }}
          >
            <path
              d="M1189.2 169.2H421H253.8C159.8 169.2 69.1 203.1 0 262.6V449.8C30.5 349.9 131.3 276.7 252 276.7H424.1H1187.4C1280.9 276.7 1371 243.2 1440 184.3V0C1408.1 97.9 1308.3 169.2 1189.2 169.2Z"
              stroke="black"
              stroke-width="2"
            ></path>
          </svg>
        </div>
      </div>
      <div id="workflow" className="z-20 relative stitch-workflow-shell -mt-[15%] ">
        <Steps />
      </div>
      <div>
        <div class="-mt-[15%] -mb-[10%] w-screen relative z-30">
          <svg
            class="inline-block fill-current   text-[#7632EC]"
            viewBox="0 0 1440 450"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1189.2 169.2H421H253.8C159.8 169.2 69.1 203.1 0 262.6V449.8C30.5 349.9 131.3 276.7 252 276.7H424.1H1187.4C1280.9 276.7 1371 243.2 1440 184.3V0C1408.1 97.9 1308.3 169.2 1189.2 169.2Z"></path>
          </svg>
        </div>
      </div>
      <div id="faqs" className="z-50 relative stitch-faq-shell">
        <Accordion />
      </div>
      <div className="z-20 relative"></div>

      <div className="h-64"></div>
    </div>
  );
}

export default App;
